const RELOAD_GUARD_KEY = 'av-chunk-reload-at';
const RELOAD_COOLDOWN_MS = 15_000;

/**
 * Detects webpack / browser failures when a lazy-loaded chunk is missing
 * (typical after a frontend deploy while a tab still holds the old HTML shell).
 */
export function isChunkLoadError(error) {
  if (!error) {
    return false;
  }

  const name = typeof error === 'object' && error !== null ? error.name : '';
  const message = String(
    (typeof error === 'object' && error !== null && error.message) || error
  );

  return (
    name === 'ChunkLoadError' ||
    /Loading chunk [\da-zA-Z_-]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /error loading dynamically imported module/i.test(message)
  );
}

let reloadScheduled = false;

export function reloadForStaleChunk() {
  if (reloadScheduled || typeof window === 'undefined') {
    return false;
  }

  const lastReloadAt = Number(window.sessionStorage.getItem(RELOAD_GUARD_KEY) || 0);
  if (lastReloadAt && Date.now() - lastReloadAt < RELOAD_COOLDOWN_MS) {
    return false;
  }

  reloadScheduled = true;
  window.sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
  window.location.reload();
  return true;
}

function handleChunkLoadFailure(error) {
  if (isChunkLoadError(error)) {
    reloadForStaleChunk();
    return true;
  }
  return false;
}

/**
 * Registers global listeners so any lazy route chunk failure triggers a hard reload.
 * Call once before React mounts.
 */
export function registerChunkLoadRecovery() {
  if (typeof window === 'undefined') {
    return;
  }

  window.addEventListener('unhandledrejection', (event) => {
    if (handleChunkLoadFailure(event.reason)) {
      event.preventDefault();
    }
  });

  window.addEventListener('error', (event) => {
    if (handleChunkLoadFailure(event.error || event.message)) {
      event.preventDefault();
    }
  });
}
